import { find } from 'lodash';

class PageContentSpadaysController {

    constructor($state, markdownService, eventsService) {
        this.$state = $state;
        this.marked = markdownService;
        this.eventsService = eventsService;
    }

    $onInit() {
        this.loading = true;
        this.eventsService.collectAll(-1).then(response => {
            this.loading = false;
            this.events = response.filter(event => {
                return event.base_price > 0;
            });
        });
    }
    
    groupEvents(item) {
        return item.type_display;
    }
}

PageContentSpadaysController.$inject = [ '$state', 'markdownService', 'eventsService' ];

export default PageContentSpadaysController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/controllers/pageContent.spadays.controller.js